module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-48.7e77ad3a.png";